/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { Classes } from "@blueprintjs/core";
var NS = Classes.getClassNamespace();
export var MULTISELECT = "".concat(NS, "-multi-select");
export var MULTISELECT_POPOVER = "".concat(MULTISELECT, "-popover");
export var MULTISELECT_TAG_INPUT_INPUT = "".concat(MULTISELECT, "-tag-input-input");
export var OMNIBAR = "".concat(NS, "-omnibar");
export var OMNIBAR_OVERLAY = "".concat(OMNIBAR, "-overlay");
/** @deprecated this class name is not rendered by any component in this package */
export var SELECT = "".concat(NS, "-select");
export var SELECT_POPOVER = "".concat(NS, "-select-popover");
export var SELECT_MATCH_TARGET_WIDTH = "".concat(NS, "-select-match-target-width");
export var SUGGEST_POPOVER = "".concat(NS, "-suggest-popover");
//# sourceMappingURL=classes.js.map